<template>
  <div>
    <nav-bar/>
    <div class="sidebar bg-darkgrey navbar-inverse side-box-shadow">
      <ul class="nav flex-column">
        <li class="nav-item">
          <a class="nav-link navbar-text pull-left" href="#/OrderPending">
            {{$t('OrderCurrent.sidebar.pending')}}
          </a>
          <span v-if="pending.length > 0" class="pull-right badge badge-default">{{ pending.length }}</span>
        </li>
        <li class="nav-item" id="current">
          <a class="nav-link navbar-text pull-left" href="#/OrderCurrent">
            {{$t('OrderCurrent.sidebar.current')}}
          </a>
        </li>
        <li class="nav-item" :class="{'current': $route.query.newNote}">
          <router-link :to="{name: 'OrderCurrent', query: {newNote: true}}" class="nav-link navbar-text pull-left pr-0">
            {{$t('OrderCurrent.sidebar.notes')}}
          </router-link>
          <span v-if="newCount.newNote > 0" class="pull-right badge badge-default">{{ newCount.newNote }}</span>
        </li>
        <li class="nav-item" :class="{'current': $route.query.newDate}">
          <router-link :to="{name: 'OrderCurrent', query: {newDate: true}}" class="nav-link navbar-text pull-left pr-0">
            {{$t('OrderCurrent.sidebar.date')}}
          </router-link>
          <span v-if="newCount.newDate > 0" class="pull-right badge badge-default">{{ newCount.newDate }}</span>
        </li>
        <li class="nav-item" :class="{'current': view.query.name === $route.query.name}" v-for="view in customViews">
          <router-link :to="{name: 'OrderCurrent', query: view.query}" class="nav-link navbar-text pull-left">
            {{view.query.name}}
          </router-link>
        </li>
        <li class="nav-item" v-if="isAdmin">
          <!-- <a class="nav-link navbar-text pull-left" href="" @click.prevent="modal.newCustomView = true">
            {{$t('OrderCurrent.sidebar.add_custom_view')}}
          </a> -->
          <button class="btn btn-sm btn-kne-orange" @click.prevent="modal.newCustomView = true">
            <i class="fa fa-plus fa-lg" aria-hidden="true"></i>
          </button>
          <button class="btn btn-sm btn-kne-orange" @click.prevent="modal.deleteCustomView = true">
            <i class="fa fa-minus fa-lg" aria-hidden="true"></i>
          </button>
        </li>
      </ul>
      <button id="addOrder" class="btn btn-kne-orange col-12 mt-3" @click="addOrderAction(); closedModal = false">
        <i class="fa fa-plus-circle fa-lg" aria-hidden="true"></i>
        {{$t('OrderPending.sidebar.add_order')}}
      </button>
    </div>

    <div class="view">
      <div class="card mb-3 bg-darkgrey">
        <div id="stats" class="color-grey">
          <div class="col-12 col-md-6 col-lg-3">
            <p class="mx-3 my-3">{{$t('OrderCurrent.stats.processing')}}: <span class="pull-right color-white">{{ newCount.processing }}</span></p>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <p class="mx-3 my-3">{{$t('OrderCurrent.stats.dispatch')}}: <span class="pull-right color-white">{{ newCount.dispatch }}</span></p>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <p class="mx-3 my-3">{{$t('OrderCurrent.stats.pick')}}: <span class="pull-right color-white">{{ newCount.pick }}</span></p>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <p class="mx-3 my-3">{{$t('OrderCurrent.stats.transit')}}: <span class="pull-right color-white">{{ newCount.transit }}</span></p>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <p class="mx-3 my-3">{{$t('OrderCurrent.stats.delivered')}}: <span class="pull-right color-white">{{ newCount.drop }}</span></p>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <p class="mx-3 my-3">{{$t('OrderCurrent.stats.transferred')}}: <span class="pull-right color-white">{{ newCount.transfer }}</span></p>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <p class="mx-3 my-3">{{$t('OrderCurrent.stats.rejected')}}: <span class="pull-right color-white">{{ newCount.reject }}</span></p>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <p class="mx-3 my-3">{{$t('OrderCurrent.stats.waiting')}}: <span class="pull-right color-white">{{ newCount.waiting }}</span></p>
          </div>
        </div>
      </div>
      <div class="card" id="orders">
        <div class="card-header">
          <h3 class="my-2">
            {{$t('OrderCurrent.title')}}
            <button v-if="$store.state.userInfo && $store.state.userInfo.isSageOne" :disabled="selected.length < 1" @click="openBilling()" class="btn btn-kne-orange">{{$t('OrderCurrent.actions.billing')}}</button>

            <!-- // test -->
            <!-- <button :disabled="selected.length < 1" @click="openBilling()" class="btn btn-kne-orange">{{$t('OrderCurrent.actions.billing')}}</button> -->
            <!-- // test -->

            <!-- <button :disabled="selected.length < 1" @click="openDispatch(false)" class="btn btn-kne-orange">{{$t('OrderCurrent.actions.dispatch')}}</button> -->
            <button :disabled="selected.length < 1" @click="openDispatch(true)" class="btn btn-kne-orange">{{$t('OrderCurrent.actions.shortDispatch')}}</button>
            <json-excel class="btn btn-kne-orange pull-right"
            v-if="isAdmin"
            :data="JSON.parse(JSON.stringify(filterResultsWithOrder))"
            :fields="customers_fields"
            :name="'order_current_' + getDate(Date.now()) + '.xls'">
              <!-- <i class="fa fa-plus-circle fa-lg" aria-hidden="true"></i> -->
              {{$t('AddressBook.sidebar.excel')}}
            </json-excel>
          </h3>
        </div>
        <paginate :refreshCurrentPage="false" ref="paginator" name="filterResults" tag="div" :list="filterResults" class="" :per="40">
        <div class="table-responsive">
          <table class="table table-hover font-grey mb-0 table-sm">
            <thead class="bg-darkgrey">
              <tr>
                <th colspan="3"></th>
                <th @click="sortBy('.key', false)" class="sortable nowrap">{{$t('OrderCurrent.order')}}<i v-if="sort.current === '.key'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <!-- <th v-if="hasIntegration" @click="sortBy('isDivisionX', false)" class="sortable nowrap">{{$t('OrderCurrent.isDivisionX')}}<i v-if="sort.current === 'isDivisionX'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th> -->
                <th @click="sortBy('numRef', false)" class="sortable nowrap">{{$t('OrderCurrent.reference')}}<i v-if="sort.current === 'numRef'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('source', false)" class="sortable nowrap">{{$t('OrderCurrent.source')}}<i v-if="sort.current === 'source'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('vin', false)" class="sortable nowrap">{{$t('OrderCurrent.VIN')}}<i v-if="sort.current === 'vin'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th v-if="isDateRoute" @click="sortBy('datePromis', false)" class="sortable nowrap">{{$t('OrderCurrent.datePromis')}}<i v-if="sort.current === 'datePromis'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('creationDate', false)" class="sortable nowrap">{{$t('OrderCurrent.date')}}<i v-if="sort.current === 'creationDate'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('transmitterName', false)" class="sortable nowrap">{{$t('OrderCurrent.pickup')}}<i v-if="sort.current === 'transmitterName'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('receiverName', false)" class="sortable nowrap">{{$t('OrderCurrent.delivery')}}<i v-if="sort.current === 'receiverName'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('payerName', false)" class="sortable nowrap">{{$t('OrderCurrent.billing')}}<i v-if="sort.current === 'payerName'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('status', false)" class="sortable nowrap">{{$t('OrderCurrent.status')}}<i v-if="sort.current === 'status'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('driverName', false)" class="sortable nowrap">{{$t('OrderCurrent.driver')}}<i v-if="sort.current === 'driverName'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
              </tr>
            </thead>
            <transition-group name="fade" tag="tbody">
              <tr key='filter'>
                <th colspan="3"></th>
                <td>
                  <regular-input
                    :value="fields['.key']"
                    @input="evaluateFiltering('.key', $event)"
                    :placeholder="$t('OrderCurrent.order')"/>
                </td>
                <!-- <td v-if="hasIntegration"></td> -->
                <td>
                  <regular-input
                    :value="fields.numRef"
                    @input="evaluateFiltering('numRef', $event)"
                    :placeholder="$t('OrderCurrent.reference')"/>
                </td>
                <td>
                  <regular-input
                    :value="fields.source"
                    @input="evaluateFiltering('source', $event)"
                    :placeholder="$t('OrderCurrent.source')"/>
                </td>
                <td>
                  <regular-input
                    :value="fields.vin"
                    @input="evaluateFiltering('vin', $event)"
                    :placeholder="$t('OrderCurrent.VIN')"/>
                </td>
                <td v-if="isDateRoute">
                  <regular-input
                    :value="fields.datePromis"
                    @input="evaluateFiltering('datePromis', $event)"
                    :placeholder="$t('OrderCurrent.datePromis')"/>
                </td>
                <td>
                  <regular-input
                    :value="fields.creationDate"
                    @input="evaluateFiltering('creationDate', $event)"
                    :placeholder="$t('OrderCurrent.date')"/>
                </td>
                <td>
                  <regular-input
                    :value="fields.transmitterName"
                    @input="evaluateFiltering('transmitterName', $event)"
                    :placeholder="$t('OrderCurrent.pickup')"/>
                </td>
                <td>
                  <regular-input
                    :value="fields.receiverName"
                    @input="evaluateFiltering('receiverName', $event)"
                    :placeholder="$t('OrderCurrent.delivery')"/>
                </td>
                <td>
                  <regular-input
                    :value="fields.payerName"
                    @input="evaluateFiltering('payerName', $event)"
                    :placeholder="$t('OrderCurrent.billing')"/>
                </td>
                <td>
                  <regular-input
                    :value="fields.status"
                    @input="evaluateFiltering('status', $event)"
                    :placeholder="$t('OrderCurrent.status')"/>
                </td>
                <td>
                  <regular-input
                    :value="fields.driverName"
                    @input="evaluateFiltering('driverName', $event)"
                    :placeholder="$t('OrderCurrent.driver')"/>
                </td>
              </tr>
              <tr v-for="order in paginated('filterResults')" :key="order['.key']" :class="{'drop': order.status === 'Drop', 'cancel': order.status === 'Cancel', 'waiting': order.status === 'Attente', 'pick': order.status === 'Pick', 'transit': order.status === 'Transit', 'dispatch': order.status === 'Dispatch', 'reject': order.status === 'Reject', }">
                <td>
                  <label class="custom-control custom-checkbox my-2 ml-2 mr-0">
                    <input :value="order['.key']" v-model="selected" type="checkbox" class="custom-control-input">
                    <span class="custom-control-indicator"></span>
                  </label>
                </td>
                <td>
                  <router-link :to="{name: 'OrderInfo', query: {orderId: order['.key']}}">
                    <input type="button" class="btn btn-kne-orange" :value="$t('OrderCurrent.view')">
                  </router-link>
                </td>
                <td v-if="!isDateRoute">
                  <a :href="order.invoice" target="_blank" @click="print(order)">
                    <!-- <input type="button" class="btn btn-kne-orange pull-right" :value="$t('OrderCurrent.view')"> -->
                    <button class="btn btn-kne-orange" :class="{'printed': order.isPrinted}">
                    <!-- <button class="btn btn-kne-orange pull-right" :class="{'printed': !order.isPrinted}"> -->
                      <i class="fa fa-print" aria-hidden="true"></i>
                    </button>
                  </a>
                </td>
                <td v-if="isDateRoute">
                    <input v-if="checkDate(order.datePromis)" type="button" class="btn btn-kne-red" :value="calcBusinessDays(order.datePromis)">
                    <input v-if="!checkDate(order.datePromis)" type="button" class="btn btn-kne-green" :value="calcBusinessDays2(order.datePromis)">
                </td>
                <td class="nowrap">{{order['.key']}}</td>
                <!-- <td v-if="hasIntegration" class="nowrap">
                  <i v-if="order.isDivisionX" class="fa fa-check" aria-hidden="true"></i>
                </td> -->
                <td class="nowrap">{{order.numRef}}</td>
                <td class="nowrap"><p class="table-fix-width">{{order.source}}</p></td>
                <td class="nowrap">{{order.vin}}</td>
                <td v-if="isDateRoute" class="nowrap">{{ order.datePromis }}</td>
                <td class="nowrap">{{ getDate(order.creationDate) }}</td>
                <td class="nowrap"><p class="table-fix-width">{{order.transmitterName}}</p></td>
                <td class="nowrap"><p class="table-fix-width">{{order.receiverName}}</p></td>
                <td class="nowrap"><p class="table-fix-width">{{order.payerName}}</p></td>
                <td class="nowrap">
                  <span v-if="order.status === 'Dispatch'">{{$t('Search.status.dispatch')}}</span>
                  <span v-if="order.status === 'Processing'">{{$t('Search.status.processing')}}</span>
                  <span v-if="order.status === 'Pick'">{{$t('Search.status.pick')}}</span>
                  <span v-if="order.status === 'Attente'">{{$t('Search.status.waiting')}}</span>
                  <span v-if="order.status === 'Transit'">{{$t('Search.status.transit')}}</span>
                  <span v-if="order.status === 'Drop'">{{$t('Search.status.drop')}}</span>
                  <span v-if="order.status === 'Cancel'">{{$t('Search.status.canceled')}}</span>
                  <span v-if="order.status === 'Terminée'">{{$t('Search.status.finished')}}</span>
                  <span v-if="order.status === 'Transférée'">{{$t('Search.status.transfered')}}</span>
                  <span v-if="order.status === 'Reject'">{{$t('Search.status.rejected')}}</span>
                </td>
                <td class="nowrap"><p class="table-fix-width">{{order.driverName}}</p></td>
              </tr>
            </transition-group>
          </table>
        </div>
        </paginate>
        <paginate-links for="filterResults" :hide-single-page="true" :limit="5"></paginate-links>
      </div>
      <transition name="fade">
        <modal
        v-if="closedModal !== true"
        @close-request="closedModal = true; clear()"
        closable>
          <div class="row">
            <div class="col-12 col-md-6 pr-0" id="Order">
              <h4 class="mx-3 kne-title">{{$t('OrderPending.orderTab.order')}}</h4>
              <div class="">
                <regular-input
                :value="order.source"
                @input="order.source = $event"
                type="text" :placeholder="$t('OrderPending.orderTab.source')" class="col-12 form-group"
                />
              </div>
              <div class="">
                <regular-input
                  :value="order.datePromis"
                  @input="order.datePromis =  $event"
                  type="date" :placeholder="$t('OrderPending.orderTab.datePromis')" class="col-12 form-group"
                />
              </div>
              <div class="">
                <regular-input
                :value="order.numRef"
                @input="order.numRef = $event"
                type="text" :placeholder="$t('OrderPending.orderTab.reference')" class="col-12 form-group"/>
              </div>
              <div class="">
                <regular-input
                :value="order.price"
                @input="order.price = $event"
                type="text" :placeholder="$t('OrderPending.orderTab.price')" class="col-12 form-group"/>
                <regular-textarea
                :value="order.comment"
                @input="order.comment = $event"
                rows="4" :placeholder="$t('OrderPending.orderTab.comment')" class="col-12 form-group"/>
              </div>
            </div>

            <div class="col-12 col-md-6 pl-0" id="vehicle">
              <h4 class="mx-3 kne-title">{{$t('OrderPending.vehicleInfoTab.vehicle_info')}}</h4>
              <div class="col-12">
                <div class="row">
                  <regular-input
                  :value="VIN"
                  @input="VIN = $event"
                  type="text" :placeholder="$t('OrderPending.vehicleInfoTab.VIN')" class="col-12 form-group"
                  />
                  <div class="col-12">
                    <button class="btn btn-kne-orange w-100 form-group" :disabled="VIN === ''" @click="validate(VIN)">{{$t('OrderPending.vehicleInfoTab.validate')}}</button>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <regular-input
                  :value="MAKE"
                  @input="MAKE = $event"
                  type="text" :placeholder="$t('OrderPending.vehicleInfoTab.make')" class="col-12 form-group"/>
                  <regular-input
                  :value="MODEL"
                  @input="MODEL = $event"
                  type="text" :placeholder="$t('OrderPending.vehicleInfoTab.model')" class="col-12 form-group"/>
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <regular-input
                  :value="YEAR"
                  @input="YEAR = $event"
                  type="text" :placeholder="$t('OrderPending.vehicleInfoTab.year')" class="col-12 form-group"/>
                  <div class="col-12">
                    <button class="btn btn-kne-orange w-100 form-group" @click="addVehicle()">{{$t('OrderPending.vehicleInfoTab.add_vehicle')}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead class="">
                  <tr>
                    <th></th>
                    <th>{{$t('OrderPending.vehicleInfoTab.VIN')}}</th>
                    <th>{{$t('OrderPending.vehicleInfoTab.year')}}</th>
                    <th>{{$t('OrderPending.vehicleInfoTab.make')}}</th>
                    <th>{{$t('OrderPending.vehicleInfoTab.model')}}</th>
                  </tr>
                </thead>
                <transition-group name="fade" tag="tbody">
                  <tr v-for="(vehicle, index) in vehicles" :key="vehicle.vin+vehicle.year">
                    <td>{{index+1}}</td>
                    <td>{{vehicle.vin}}</td>
                    <td>{{vehicle.year}}</td>
                    <td>{{vehicle.make}}</td>
                    <td>{{vehicle.model}}</td>
                  </tr>
                </transition-group>
              </table>
            </div>
          </div>
          <div class="row">
            <div class="mt-3 col-4 pr-0" id="pickup">
              <h4 class="mx-3 kne-title">{{$t('OrderPending.pickupDeliveryTab.pickup')}}</h4>
              <regular-datalist
              :value="datalist.pickup"
              @input="setAndSearch($event, 'pickup')"
              :originalList="$store.state.allContacts"
              :secondList="addressbook"
              :placeholder="$t('AddressBook.title')" class="col-12 form-group"/>
              <regular-input
              :value="order.transmitterName"
              @input="order.transmitterName = $event"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.name') + '*'" class="col-12 form-group"/>
              <regular-input
              :value="order.transmitterAddress"
              @input="order.transmitterAddress = $event"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.address') + '*'" class="col-12 form-group"/>
              <regular-input
              :value="order.transmitterCity"
              @input="order.transmitterCity = $event"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.city')" class="col-12 form-group"/>
              <regular-input
              :value="order.transmitterPostcode"
              @input="order.transmitterPostcode = $event"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.postal_code')" class="col-12 form-group"/>
              <regular-input
              :value="order.transmitterProvince"
              @input="order.transmitterProvince = $event"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.province')" class="col-12 form-group"/>
              <regular-input
              :value="order.transmitterCountry"
              @input="order.transmitterCountry = $event"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.country')" class="col-12 form-group"/>
              <regular-input
              :value="order.transmitterEmail"
              @input="order.transmitterEmail = $event"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.email')" class="col-12 form-group"/>
              <regular-input
              :value="order.transmitterPhone"
              @input="order.transmitterPhone = $event"
              type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.phone')" class="col-12 form-group"/>
              <regular-input
              :value="order.transmitterFax"
              @input="order.transmitterFax = $event"
              type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.fax')" class="col-12 form-group"/>
              <regular-input
              :value="order.transmitterContact"
              @input="order.transmitterContact = $event"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.contact')" class="col-12 form-group"/>
              <regular-checkbox
              :checked="pickupSave"
              @change="pickupSave = $event"
              :label="$t('OrderPending.pickupDeliveryTab.save_dealer')" class="col-12"/>
            </div>

            <div class="mt-3 col-4 px-0" id="delivery">
              <h4 class="mx-3 kne-title">{{$t('OrderPending.pickupDeliveryTab.delivery')}}</h4>
              <regular-datalist
              :value="datalist.delivery"
              @input="setAndSearch($event, 'delivery')"
              :originalList="$store.state.allContacts"
              :secondList="addressbook"
              :placeholder="$t('AddressBook.title')" class="col-12 form-group"/>
              <regular-input
              :value="order.receiverName"
              @input="order.receiverName = $event; onInputBillingSame()"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.name') + '*'" class="col-12 form-group"/>
              <regular-input
              :value="order.receiverAddress"
              @input="order.receiverAddress = $event; onInputBillingSame()"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.address') + '*'" class="col-12 form-group"/>
              <regular-input
              :value="order.receiverCity"
              @input="order.receiverCity = $event; onInputBillingSame()"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.city')" class="col-12 form-group"/>
              <regular-input
              :value="order.receiverPostcode"
              @input="order.receiverPostcode = $event; onInputBillingSame()"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.postal_code')" class="col-12 form-group"/>
              <regular-input
              :value="order.receiverProvince"
              @input="order.receiverProvince = $event; onInputBillingSame()"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.province')" class="col-12 form-group"/>
              <regular-input
              :value="order.receiverCountry"
              @input="order.receiverCountry = $event; onInputBillingSame()"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.country')" class="col-12 form-group"/>
              <regular-input
              :value="order.receiverEmail"
              @input="order.receiverEmail = $event"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.email')" class="col-12 form-group"/>
              <regular-input
              :value="order.receiverPhone"
              @input="order.receiverPhone = $event; onInputBillingSame()"
              type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.phone')" class="col-12 form-group"/>
              <regular-input
              :value="order.receiverFax"
              @input="order.receiverFax = $event; onInputBillingSame()"
              type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.fax')" class="col-12 form-group"/>
              <regular-input
              :value="order.receiverContact"
              @input="order.receiverContact = $event; onInputBillingSame()"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.contact')" class="col-12 form-group"/>
              <regular-checkbox
              :checked="deliverySave"
              @change="deliverySave = $event"
              :label="$t('OrderPending.pickupDeliveryTab.save_dealer')" class="col-12"/>
            </div>

            <div class="mt-3 col-4 pl-0" id="billing">
              <h4 class="mx-3 kne-title">{{$t('OrderPending.pickupDeliveryTab.billing')}}</h4>
              <regular-datalist
              :value="datalist.billing"
              @input="setAndSearch($event, 'billing')"
              :disabled="billingSame"
              :originalList="$store.state.allContacts"
              :secondList="isSageOne ? sageIDonly : addressbook"
              :placeholder="$t('AddressBook.title')" class="col-12 form-group"/>
              <regular-input
              :value="order.payerName"
              @input="order.payerName = $event"
              :disabled="billingSame"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.name') + '*'" class="col-12 form-group"/>
              <regular-input
              :value="order.payerAddress"
              @input="order.payerAddress = $event"
              :disabled="billingSame"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.address') + '*'" class="col-12 form-group"/>
              <regular-input
              :value="order.payerCity"
              @input="order.payerCity = $event"
              :disabled="billingSame"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.city')" class="col-12 form-group"/>
              <regular-input
              :value="order.payerPostcode"
              @input="order.payerPostcode = $event"
              :disabled="billingSame"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.postal_code')" class="col-12 form-group"/>
              <regular-input
              :value="order.payerProvince"
              @input="order.payerProvince = $event"
              :disabled="billingSame"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.province')" class="col-12 form-group"/>
              <regular-input
              :value="order.payerCountry"
              @input="order.payerCountry = $event"
              :disabled="billingSame"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.country')" class="col-12 form-group"/>
              <regular-input
              :value="order.payerEmail"
              @input="order.payerEmail = $event"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.email')" class="col-12 form-group"/>
              <regular-input
              :value="order.payerPhone"
              @input="order.payerPhone = $event"
              :disabled="billingSame"
              type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.phone')" class="col-12 form-group"/>
              <regular-input
              :value="order.payerFax"
              @input="order.payerFax = $event"
              :disabled="billingSame"
              type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.fax')" class="col-12 form-group"/>
              <regular-input
              :value="order.payerContact"
              @input="order.payerContact = $event"
              :disabled="billingSame"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.contact')" class="col-12 form-group"/>
              <regular-checkbox
              :checked="billingSame"
              @change="billingSame = $event"
              :label="$t('OrderPending.pickupDeliveryTab.same_as_delivery')" class="col-12"/>
            </div>
          </div>

          <div class="col-12">
            <button class="btn btn-kne-orange w-100" :disabled="!formCompleted || !sageOneCheck" @click="addOrder()">{{$t('OrderPending.submitOrder')}}</button>
          </div>
        </modal>
      </transition>
      <transition name="fade">
        <modal
        v-if="billing || dispatch || shortDispatch"
        @close-request="billing = false; dispatch = false; shortDispatch = false; clear()"
        closable>
          <div v-if="billing" class="container-fluid">
            <h3>{{$t('OrderCurrent.actions.billing')}}<span class="pull-right h6 mt-2">{{$t('OrderCurrent.count')}} {{selected.length}}</span></h3>
            <div class="table-responsive">
              <table class="table table-hover font-grey mb-0 table-sm">
                <thead class="bg-darkgrey">
                  <tr>
                    <th>{{$t('OrderCurrent.order')}}</th>
                    <th>{{$t('OrderCurrent.payer')}}</th>
                    <th>{{$t('OrderCurrent.sageID')}}</th>
                    <th>{{$t('OrderCurrent.price')}}</th>
                    <th>{{$t('OrderCurrent.taxes')}}</th>
                    <th>{{$t('OrderCurrent.taxescomment')}}</th>
                    <th>{{$t('OrderCurrent.billingDate')}}</th>
                  </tr>
                </thead>
                <transition-group name="fade" tag="tbody">
                  <tr v-for="(order, index) in selectedFull" :key="index">
                    <td>{{selected[index]}}</td>
                    <td>{{selectedFull[index].payerName}}</td>
                    <td>
                      <i v-if="order.sageID && order.sageID !== ''" class="fa fa-check" aria-hidden="true"></i>
                    </td>
                    <td>
                      <regular-input
                      min="0"
                      :value="order.price"
                      @input="order.price = $event"
                      type="number" :placeholder="$t('OrderCurrent.price')"/>
                    </td>
                    <td>
                      <regular-select
                      :value="order.taxes"
                      @change="order.taxes = $event"
                      :placeholder="$t('OrderInfo.modal.tax')">
                        <option v-for="province in $store.state.provinces" :value="province">{{province}}</option>
                      </regular-select>
                    </td>
                    <td>
                      <regular-input
                      :value="order.taxesComment"
                      @input="order.taxesComment = $event"
                      type="text" :placeholder="$t('OrderCurrent.taxescomment')"/>
                    </td>
                    <td>
                      <regular-input
                      :value="order.billingDate"
                      @input="order.billingDate = formatDate($event)"
                      type="date" :placeholder="$t('OrderCurrent.billingDate')"/>
                      <button v-if="index === 0" class="mt-1 btn btn-kne-orange w-100" @click="applyBillingDateToAll(order.billingDate)">{{$t('OrderCurrent.sameBillingDate')}}</button>
                    </td>
                  </tr>
                </transition-group>
              </table>
              <div class="pull-right mt-3">
                <a target="_blank" :href="'https://mysageone.ca.sageone.com/oauth2/auth?response_type=code&client_id=3ff1477e6ec457b7df62&redirect_uri=https://systems.keepneye.com/api4/SageoneToken&scope=full_access&transpuid=' + companyUID + '&commandid=' + allOrderID ">
                  <button :disabled="!allBillingFieldCompleted" @click="saveBilling()" class="btn btn-kne-orange">{{$t('OrderCurrent.modal.confirm')}}</button>
                </a>
                <button @click="billing = false; clear()" class="btn btn-danger">{{$t('OrderCurrent.modal.cancel')}}</button>
              </div>
            </div>
          </div>
          <div v-if="dispatch" class="container-fluid">
            <h3>{{$t('OrderCurrent.actions.dispatch')}}</h3>
            <regular-datalist-driver
            v-if="dispatch"
            :value="dispatchOrder.chauffeurName"
            @input="dispatchOrder.chauffeurName = $event.value; dispatchOrder.chauffeur = $event.key"
            :secondList="liste"
            :placeholder="$t('OrderInfo.modal.driver')" class="col-12 form-group"/>
            <div class="tab-content row">
              <div class="mt-3 col-6 pr-0" id="pickup">
                <h4 class="mx-3 kne-title">{{$t('OrderInfo.modal.pickup.title')}}</h4>
                <regular-datalist
                :value="datalist.pickup"
                @input="setAndSearch($event, 'pickup')"
                :originalList="$store.state.allContacts"
                :secondList="addressbook"
                :placeholder="$t('AddressBook.title')" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterName"
                @input="order.transmitterName = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.name') + '*'" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterAddress"
                @input="order.transmitterAddress = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.address') + '*'" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterCity"
                @input="order.transmitterCity = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.city')" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterPostcode"
                @input="order.transmitterPostcode = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.postal_code')" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterProvince"
                @input="order.transmitterProvince = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.province')" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterCountry"
                @input="order.transmitterCountry = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.country')" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterEmail"
                @input="order.transmitterEmail = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.email')" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterPhone"
                @input="order.transmitterPhone = $event"
                type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.phone')" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterFax"
                @input="order.transmitterFax = $event"
                type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.fax')" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterContact"
                @input="order.transmitterContact = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.contact')" class="col-12 form-group"/>
              </div>

              <div class="mt-3 col-6 pl-0" id="delivery">
                <h4 class="mx-3 kne-title">{{$t('OrderInfo.modal.delivery.title')}}</h4>
                <regular-datalist
                :value="datalist.delivery"
                @input="setAndSearch($event, 'delivery')"
                :originalList="$store.state.allContacts"
                :secondList="addressbook"
                :placeholder="$t('AddressBook.title')" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverName"
                @input="order.receiverName = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.name') + '*'" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverAddress"
                @input="order.receiverAddress = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.address') + '*'" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverCity"
                @input="order.receiverCity = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.city')" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverPostcode"
                @input="order.receiverPostcode = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.postal_code')" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverProvince"
                @input="order.receiverProvince = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.province')" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverCountry"
                @input="order.receiverCountry = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.country')" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverEmail"
                @input="order.receiverEmail = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.email')" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverPhone"
                @input="order.receiverPhone = $event"
                type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.phone')" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverFax"
                @input="order.receiverFax = $event"
                type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.fax')" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverContact"
                @input="order.receiverContact = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.contact')" class="col-12 form-group"/>
              </div>
            </div>
            <h4 class="mx-3 kne-title">Information</h4>
            <div class=" pt-4">
              <div class="col-12">
                <div class="row">
                  <regular-input
                  :value="order.numRef"
                  @input="order.numRef = $event"
                  type="text" :placeholder="$t('OrderInfo.modal.reference')" class="col-12 col-sm-6 form-group"/>
                  <regular-input
                  :value="order.price"
                  @input="order.price = $event"
                  type="number" :placeholder="$t('OrderInfo.modal.price')" class="col-12 col-sm-6 form-group"/>
                  <regular-textarea
                  :value="order.comment"
                  @input="order.comment = $event"
                  :placeholder="$t('OrderInfo.modal.comment')" class="col-12 form-group" rows="6"/>
                </div>
                <button class="btn btn-kne-orange w-100" :disabled="!dispatchFormFilled" @click="dispatchAction()">{{$t('OrderInfo.modal.dispatch')}}</button>
              </div>
            </div>
          </div>
          <div v-if="shortDispatch" class="container-fluid">
            <h3>{{$t('OrderCurrent.actions.shortDispatch')}}<span class="pull-right h6 mt-2">{{$t('OrderCurrent.count')}} {{selected.length}}</span></h3>
            <regular-datalist-driver
            :value="dispatchOrder.chauffeurName"
            @input="dispatchOrder.chauffeurName = $event.value; dispatchOrder.chauffeur = $event.key"
            :secondList="liste"
            :placeholder="$t('OrderInfo.modal.driver')" class="col-12 form-group"/>
            <div class="table-responsive">
              <table class="table table-hover font-grey mb-0 table-sm">
                <thead class="bg-darkgrey">
                  <tr>
                    <th>{{$t('OrderCurrent.order')}}</th>
                    <th>{{$t('OrderInfo.modal.pickup.title')}}</th>
                    <th>{{$t('OrderInfo.modal.delivery.title')}}</th>
                    <th>{{$t('OrderCurrent.price')}}</th>
                    <th>{{$t('OrderInfo.modal.reference')}}</th>
                    <th>{{$t('OrderCurrent.taxescomment')}}</th>
                  </tr>
                </thead>
                <transition-group name="fade" tag="tbody">
                  <tr v-for="(order, index) in selectedFull" :key="index">
                    <td>{{selected[index]}}</td>
                    <td>{{selectedFull[index].transmitterName}}</td>
                    <td>{{selectedFull[index].receiverName}}</td>
                    <td>
                      <regular-input
                      min="0"
                      :value="order.price"
                      @input="order.price = $event"
                      type="number" :placeholder="$t('OrderCurrent.price')"/>
                    </td>
                    <td>
                      <regular-input
                      min="0"
                      :value="order.numRef"
                      @input="order.numRef = $event"
                      type="text" :placeholder="$t('OrderInfo.modal.reference')"/>
                    </td>
                    <td>
                      <regular-input
                      :value="order.comment"
                      @input="order.comment = $event"
                      type="text" :placeholder="$t('OrderCurrent.taxescomment')"/>
                    </td>
                  </tr>
                </transition-group>
              </table>
              <div class="pull-right mt-3">
                <button :disabled="dispatchOrder.chauffeur === null || dispatchOrder.chauffeur === ''" @click="shortDispatchAction()" class="btn btn-kne-orange">{{$t('OrderCurrent.modal.confirm')}}</button>
                <button @click="shortDispatch = false; clear()" class="btn btn-danger">{{$t('OrderCurrent.modal.cancel')}}</button>
              </div>
            </div>
          </div>
        </modal>
      </transition>
      <!-- New custom view modal -->
      <transition name="fade">
        <modal
        v-if="modal.newCustomView"
        @close-request="modal.newCustomView = false; clear()"
        closable>
          <div class="container-fluid">
            <h3>{{$t('OrderCurrent.sidebar.add_custom_view')}}</h3>
            <div class="row">
              <regular-input
              :value="newCustomView.name"
              @input="newCustomView.name = $event"
              type="text" :placeholder="$t('OrderCurrent.modal.name')" class="col-12 form-group"/>
              <regular-input
              :value="newCustomView.VIN"
              @input="newCustomView.VIN = $event"
              type="text" :placeholder="$t('Search.VIN')" class="col-12 col-sm-6 form-group"/>
              <regular-input
              :value="newCustomView.referenceNumber"
              @input="newCustomView.referenceNumber = $event"
              type="text" :placeholder="$t('Search.reference')" class="col-12 col-sm-6 form-group"/>
              <regular-input
              :value="newCustomView.source"
              @input="newCustomView.source = $event"
              type="text" :placeholder="$t('Search.source')" class="col-12 col-sm-6 form-group"/>
              <regular-input
              :value="newCustomView.pickup"
              @input="newCustomView.pickup = $event"
              type="text" :placeholder="$t('Search.pickup')" class="col-12 col-sm-6 form-group"/>
              <regular-input
              :value="newCustomView.delivery"
              @input="newCustomView.delivery = $event"
              type="text" :placeholder="$t('Search.delivery')" class="col-12 col-sm-6 form-group"/>
              <regular-input
              :value="newCustomView.billing"
              @input="newCustomView.billing = $event"
              type="text" :placeholder="$t('Search.billing')" class="col-12 col-sm-6 form-group"/>
              <regular-select
              :value="newCustomView.status"
              @change="newCustomView.status = $event"
              :placeholder="$t('Search.status.status')" class="col-12 col-sm-6 form-group">
                <option value="Dispatch">{{$t('Search.status.dispatch')}}</option>
                <option value="Pick">{{$t('Search.status.pick')}}</option>
                <option value="Transit">{{$t('Search.status.transit')}}</option>
                <option value="Drop">{{$t('Search.status.drop')}}</option>
                <option value="Cancel">{{$t('Search.status.canceled')}}</option>
                <option value="Terminée">{{$t('Search.status.finished')}}</option>
                <option value="Transférée">{{$t('Search.status.transfered')}}</option>
                <option value="Reject">{{$t('Search.status.rejected')}}</option>
                <option value="Attente">{{$t('Search.status.waiting')}}</option>
              </regular-select>
              <regular-datalist-driver
              :value="newCustomView.driver"
              @input="newCustomView.driver = $event.value"
              :secondList="liste"
              :placeholder="$t('Search.driver')" class="col-12 col-sm-6 form-group"/>
              <regular-select
              :value="newCustomView.provincePick"
              @change="newCustomView.provincePick = $event"
              :placeholder="$t('OrderCurrent.modal.provinceOrigin')" class="col-12 col-sm-6 form-group">
                <option value="AB">{{$t('OrderCurrent.province.AB')}}</option>
                <option value="BC">{{$t('OrderCurrent.province.BC')}}</option>
                <option value="MB">{{$t('OrderCurrent.province.MB')}}</option>
                <option value="NB">{{$t('OrderCurrent.province.NB')}}</option>
                <option value="NL">{{$t('OrderCurrent.province.NL')}}</option>
                <option value="NS">{{$t('OrderCurrent.province.NS')}}</option>
                <option value="NT">{{$t('OrderCurrent.province.NT')}}</option>
                <option value="NU">{{$t('OrderCurrent.province.NU')}}</option>
                <option value="ON">{{$t('OrderCurrent.province.ON')}}</option>
                <option value="PE">{{$t('OrderCurrent.province.PE')}}</option>
                <option value="QC">{{$t('OrderCurrent.province.QC')}}</option>
                <option value="SK">{{$t('OrderCurrent.province.SK')}}</option>
                <option value="YT">{{$t('OrderCurrent.province.YT')}}</option>
              </regular-select>
              <regular-select
              :value="newCustomView.provinceDrop"
              @change="newCustomView.provinceDrop = $event"
              :placeholder="$t('OrderCurrent.modal.provinceArrival')" class="col-12 col-sm-6 form-group">
                <option value="AB">{{$t('OrderCurrent.province.AB')}}</option>
                <option value="BC">{{$t('OrderCurrent.province.BC')}}</option>
                <option value="MB">{{$t('OrderCurrent.province.MB')}}</option>
                <option value="NB">{{$t('OrderCurrent.province.NB')}}</option>
                <option value="NL">{{$t('OrderCurrent.province.NL')}}</option>
                <option value="NS">{{$t('OrderCurrent.province.NS')}}</option>
                <option value="NT">{{$t('OrderCurrent.province.NT')}}</option>
                <option value="NU">{{$t('OrderCurrent.province.NU')}}</option>
                <option value="ON">{{$t('OrderCurrent.province.ON')}}</option>
                <option value="PE">{{$t('OrderCurrent.province.PE')}}</option>
                <option value="QC">{{$t('OrderCurrent.province.QC')}}</option>
                <option value="SK">{{$t('OrderCurrent.province.SK')}}</option>
                <option value="YT">{{$t('OrderCurrent.province.YT')}}</option>
              </regular-select>
              <regular-input
              :value="newCustomView.dateReceptionMin"
              @input="newCustomView.dateReceptionMin = $event"
              type="date" placeholder="Date min" class="col-12 col-sm-6 form-group"/>
              <regular-input
              :value="newCustomView.dateReceptionMax"
              @input="newCustomView.dateReceptionMax = $event"
              type="date" placeholder="Date max" class="col-12 col-sm-6 form-group"/>
              <regular-input
              :value="newCustomView.afterXDays"
              @input="newCustomView.afterXDays = $event"
              type="number" :placeholder="$t('OrderCurrent.modal.after_x_days')" class="col-12 col-sm-6 form-group"/>
              <regular-input
              :value="newCustomView.beforeXDays"
              @input="newCustomView.beforeXDays = $event"
              type="number" :placeholder="$t('OrderCurrent.modal.before_x_days')" class="col-12 col-sm-6 form-group"/>
              <div class="col-12">
                <button class="btn btn-kne-orange w-100" :disabled="newCustomView.name === ''" @click="addCustomView()">
                  {{$t('OrderCurrent.modal.confirm')}}
                </button>
              </div>
            </div>
          </div>
        </modal>
      </transition>
      <!-- Delete custom view modal -->
      <transition name="fade">
        <modal
        v-if="modal.deleteCustomView"
        @close-request="modal.deleteCustomView = false; clear()"
        closable>
          <div class="container-fluid">
            <h3>{{$t('OrderCurrent.sidebar.delete_custom_view')}}</h3>
            <div class="row">
              <regular-select
              :value="selectedCustomView"
              @change="selectedCustomView = $event"
              :placeholder="$t('OrderCurrent.modal.custom_view')" class="col-12 form-group">
                <option v-for="view in customViews" :value="view['.key']">{{view.query.name}}</option>
              </regular-select>
              <div class="col-12">
                <div class="pull-right">
                  <button class="btn btn-kne-orange" :disabled="selectedCustomView === ''" @click="deleteCustomView()">
                    {{$t('OrderCurrent.modal.confirm')}}
                  </button>
                  <button class="btn btn-danger" @click="modal.deleteCustomView = false">
                    {{$t('OrderCurrent.modal.cancel')}}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </modal>
      </transition>
    </div>
  </div>
</template>

<script>
import Modal from '../Modal.vue'
import regularInput from '../regularInput.vue'
import regularCheckbox from '../regularCheckbox.vue'
import regularTextarea from '../regularTextarea.vue'
import regularSelect from '../regularSelect.vue'
import Search from '../module/Search.vue'
import {db} from '../../firebase'
import _ from 'lodash'
import regularDatalistDriver from '../regularDatalistDriver.vue'
import moment from 'moment'
import JsonExcel from 'vue-json-excel'

export default {
  name: 'orderCurrent',
  components: {
    Modal,
    regularInput,
    regularCheckbox,
    regularTextarea,
    regularSelect,
    Search,
    regularDatalistDriver,
    JsonExcel
  },
  data () {
    return {
      customers_fields: {
        'Commande': 'order',
        'Référence': 'numRef',
        'source': 'source',
        'VIN': 'vin',
        'Date': {
          field: 'creationDate',
          callback: (value) => {
            return this.getDate(value)
          }
        },
        'Cueillette': 'transmitterName',
        'Livraison': 'receiverName',
        'Facturation': 'payerName',
        'status': 'status',
        'Chauffeur': 'driverName',
        'Province de cueillette': 'provincePick',
        'Province de livraison': 'provinceDrop',
        'Remarque': 'remark'
      },
      VIN: '',
      MAKE: '',
      MODEL: '',
      YEAR: '',
      vehicles: [],
      pickupSave: false,
      deliverySave: false,
      billingSame: false,
      order: {
        comment: '',
        latitude: 0.001,
        longitude: 0.001,
        make: '',
        model: '',
        nbDispatch: 0,
        numRef: '',
        payer: '',
        payerAddress: '',
        payerCity: '',
        payerContact: '',
        payerFax: '',
        payerName: '',
        payerPhone: '',
        payerEmail: '',
        payerPostcode: '',
        payerCountry: '',
        payerProvince: '',
        price: '',
        billNum: '',
        receiver: '',
        receiverAddress: '',
        receiverCity: '',
        receiverContact: '',
        receiverFax: '',
        receiverName: '',
        receiverPhone: '',
        receiverEmail: '',
        receiverPostcode: '',
        receiverCountry: '',
        receiverProvince: '',
        status: 'Processing',
        source: '',
        datePromis: '',
        sageID: '',
        transmitter: '',
        transmitterAddress: '',
        transmitterCity: '',
        transmitterContact: '',
        transmitterFax: '',
        transmitterName: '',
        transmitterPhone: '',
        transmitterEmail: '',
        transmitterPostcode: '',
        transmitterCountry: '',
        transmitterProvince: '',
        transpCigle: '',
        transpName: '',
        vin: '',
        year: ''
      },
      datalist: {
        pickup: '',
        pickupUid: '',
        delivery: '',
        deliveryUid: '',
        billing: '',
        billingUid: ''
      },
      closedModal: true,
      fields: {
        '.key': '',
        numRef: '',
        source: '',
        vin: '',
        datePromis: '',
        creationDate: '',
        receiverName: '',
        transmitterName: '',
        payerName: '',
        status: '',
        driverName: ''
      },
      backup: {
        sageIDDelivery: ''
      },
      filterResults: [],
      processing: [],
      paginate: ['filterResults'],
      sort: {
        current: '.key',
        desc: true
      },
      addressbook: [],
      selected: [],
      selectedFull: [],
      billing: false,
      dispatch: false,
      shortDispatch: false,
      dispatchOrder: {
        chauffeur: '',
        chauffeurName: ''
      },
      modal: {
        newCustomView: false,
        deleteCustomView: false
      },
      newCustomView: {
        name: '',
        VIN: '',
        referenceNumber: '',
        source: '',
        pickup: '',
        delivery: '',
        billing: '',
        status: '',
        dateReceptionMin: '',
        dateReceptionMax: '',
        driver: '',
        afterXDays: '',
        beforeXDays: '',
        provincePick: '',
        provinceDrop: ''
      },
      customViews: [],
      selectedCustomView: ''
    }
  },
  created () {
    this.$bindAsArray('processing', db.ref('test/transporter/' + this.companyUID + '/deliveries/'), null, () => {
      this.filteredSearchMethod()
    })
    this.$bindAsArray('pending', db.ref('database/transporter/' + this.companyUID + '/unprocessed'))
    this.$bindAsArray('liste', db.ref('database/transporter/' + this.companyUID + '/liste'))
    this.$bindAsArray('customViews', db.ref('database/transporter/' + this.companyUID + '/customViews'))
  },
  methods: {
    deleteCustomView () {
      db.ref('database/transporter/' + this.companyUID + '/customViews').child(this.selectedCustomView).set(null).then(() => {
        this.modal.deleteCustomView = false
        this.selectedCustomView = ''
      }).catch((error) => {
        console.log(error)
      })
    },
    daysBetweenNow (date1) {
      var oneDay = 24 * 60 * 60 * 1000
      var firstDate = new Date(date1)
      var secondDate = new Date()
      var diffDays2 = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)))
      return diffDays2
    },
    calcBusinessDays (start2) {
      // This makes no effort to account for holidays
      // Counts end day, does not count start day

      // make copies we can normalize without changing passed in objects
      var start = new Date(start2)
      var end = new Date()

      // initial total
      var totalBusinessDays = 0

      // normalize both start and end to beginning of the day
      start.setHours(0, 0, 0, 0)
      end.setHours(0, 0, 0, 0)

      var current = new Date(start)
      current.setDate(current.getDate() + 1)
      var day
      // loop through each day, checking
      while (current <= end) {
        day = current.getDay()
        if (day >= 1 && day <= 5) {
          ++totalBusinessDays
        }
        current.setDate(current.getDate() + 1)
      }
      return totalBusinessDays
    },
    calcBusinessDays2 (start2) {
      // This makes no effort to account for holidays
      // Counts end day, does not count start day

      // make copies we can normalize without changing passed in objects
      var start = new Date()
      var end = new Date(start2)

      // initial total
      var totalBusinessDays = 0

      // normalize both start and end to beginning of the day
      start.setHours(0, 0, 0, 0)
      end.setHours(0, 0, 0, 0)

      var current = new Date(start)
      current.setDate(current.getDate() + 1)
      var day
      // loop through each day, checking
      while (current <= end) {
        day = current.getDay()
        if (day >= 1 && day <= 5) {
          ++totalBusinessDays
        }
        current.setDate(current.getDate() + 1)
      }
      return totalBusinessDays
    },
    checkDate (date1) {
      var firstDate = new Date(date1)
      var secondDate = new Date()
      if (firstDate <= secondDate) {
        return true
      } else {
        return false
      }
    },
    addCustomView () {
      var nv = this.newCustomView
      var custom = {query: {name: nv.name, customView: true}}
      if (nv.VIN !== '') custom.query.vin = nv.VIN
      if (nv.referenceNumber !== '') custom.query.reference = nv.referenceNumber
      if (nv.source !== '') custom.query.source = nv.source
      if (nv.pickup !== '') custom.query.pickup = nv.pickup
      if (nv.delivery !== '') custom.query.delivery = nv.delivery
      if (nv.dateReceptionMin !== '') custom.query.from = Date.parse(nv.dateReceptionMin)
      if (nv.dateReceptionMax !== '') custom.query.to = Date.parse(nv.dateReceptionMax)
      if (nv.status !== '') custom.query.status = nv.status
      if (nv.billing !== '') custom.query.billing = nv.billing
      if (nv.driver !== '') custom.query.driver = nv.driver
      if (nv.afterXDays !== '') custom.query.after = parseInt(nv.afterXDays)
      if (nv.beforeXDays !== '') custom.query.before = parseInt(nv.beforeXDays)
      if (nv.provincePick !== '') custom.query.provincePick = nv.provincePick
      if (nv.provinceDrop !== '') custom.query.provinceDrop = nv.provinceDrop
      db.ref('database/transporter/' + this.companyUID + '/customViews').push().set(custom).then(() => {
        this.modal.newCustomView = false
        this.clear()
      }).catch((error) => {
        console.log(error)
      })
    },
    goToCustomView (to) {
      this.$router.go(to)
    },
    applyBillingDateToAll (date) {
      this.selectedFull.forEach((element) => {
        element.billingDate = date
      })
    },
    openDispatch (short) {
      this.fetchSelected('DISPATCH')
      this.addOrderAction()
      short ? this.shortDispatch = true : this.dispatch = true
    },
    shortDispatchAction () {
      this.selectedFull.forEach((order, index) => {
        var dispatchOrder = {
          'chauffeur': this.dispatchOrder.chauffeur,
          'chauffeurName': this.dispatchOrder.chauffeurName,
          'nbDispatch': order.nbDispatch,
          'comment': order.comment,
          'numRef': order.numRef,
          'prix': order.price,
          'receiver': order.receiverName,
          'receiverAddress': order.receiverAddress,
          'receiverCity': order.receiverCity,
          'receiverContact': order.receiverContact,
          'receiverFax': order.receiverFax,
          'receiverName': order.receiverName,
          'receiverPhone': order.receiverPhone,
          'receiverEmail': order.receiverEmail || '',
          'receiverPostcode': order.receiverPostcode || '',
          'receiverProvince': order.receiverProvince || '',
          'receiverCountry': order.receiverCountry,
          'transmitter': order.transmitterName,
          'transmitterAddress': order.transmitterAddress,
          'transmitterCity': order.transmitterCity,
          'transmitterContact': order.transmitterContact,
          'transmitterFax': order.transmitterFax,
          'transmitterName': order.transmitterName,
          'transmitterPhone': order.transmitterPhone,
          'transmitterEmail': order.transmitterEmail || '',
          'transmitterPostcode': order.transmitterPostcode || '',
          'transmitterProvince': order.transmitterProvince || '',
          'transmitterCountry': order.transmitterCountry || '',
          'dateDispatch': this.getDate(Date.now())
        }
        db.ref('test/transporter/' + this.companyUID + '/newDispatch/' + this.selected[index]).push().set(dispatchOrder)
        // ======================== ADD FAST DISPATCH LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'FAST_DISPATCH', 'orderID': this.selected[index], 'date': Date.now()})
        // ======================== ADD FAST DISPATCH LOG =======================
      })
      this.shortDispatch = false
      this.selected = []
      this.selectedFull = []
      this.dispatchOrder.chauffeur = ''
      this.dispatchOrder.chauffeurName = ''
    },
    dispatchAction () {
      var dispatchOrder = {
        'chauffeur': this.dispatchOrder.chauffeur,
        'chauffeurName': this.dispatchOrder.chauffeurName,
        'nbDispatch': this.order.nbDispatch,
        'comment': this.order.comment,
        'numRef': this.order.numRef,
        'prix': this.order.price,
        'receiver': this.order.receiverName,
        'receiverAddress': this.order.receiverAddress,
        'receiverCity': this.order.receiverCity,
        'receiverContact': this.order.receiverContact,
        'receiverFax': this.order.receiverFax || '',
        'receiverName': this.order.receiverName,
        'receiverPhone': this.order.receiverPhone,
        'receiverEmail': this.order.receiverEmail || '',
        'receiverPostcode': this.order.receiverPostcode,
        'receiverProvince': this.order.receiverProvince,
        'receiverCountry': this.order.receiverCountry,
        'transmitter': this.order.transmitterName,
        'transmitterAddress': this.order.transmitterAddress,
        'transmitterCity': this.order.transmitterCity,
        'transmitterContact': this.order.transmitterContact,
        'transmitterFax': this.order.transmitterFax || '',
        'transmitterName': this.order.transmitterName,
        'transmitterPhone': this.order.transmitterPhone,
        'transmitterEmail': this.order.transmitterEmail || '',
        'transmitterPostcode': this.order.transmitterPostcode,
        'transmitterProvince': this.order.transmitterProvince,
        'transmitterCountry': this.order.transmitterCountry,
        'dateDispatch': this.getDate(Date.now())
      }
      this.selected.forEach((element) => {
        db.ref('test/transporter/' + this.companyUID + '/newDispatch/' + element).push().set(dispatchOrder)
      })
      this.dispatch = false
      this.selected = []
      this.selectedFull = []
    },
    saveBilling () {
      this.selectedFull.forEach((element, index) => {
        // console.log(this.selected[index])
        db.ref('database').child('transporter').child(this.companyUID).child('deliveries').child(this.selected[index]).update({'price': element.price, 'taxes': element.taxes, 'taxesComment': element.taxesComment, 'billingDate': element.billingDate}).then(() => {
          // ======================== ADD FAST BILLING LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'FAST_BILLING', 'orderID': this.selected[index], 'date': Date.now()})
          // ======================== ADD FAST BILLING LOG =======================
        })
      })
      this.billing = false
      this.selectedFull = []
      this.selected = []
    },
    openBilling () {
      this.fetchSelected('BILLING')
      this.billing = true
    },
    fetchSelected (action) {
      this.selectedFull = []
      this.selected.forEach((element) => {
        db.ref('database').child('transporter').child(this.companyUID).child('deliveries').child(element).once('value').then((snap) => {
          this.$set(this.selectedFull, this.selectedFull.length, snap.val())
          if (action === 'DISPATCH' || (action === 'BILLING' && !snap.val().price)) {
            this.$set(this.selectedFull[this.selectedFull.length - 1], 'price', '')
            if (action === 'DISPATCH') {
              this.$set(this.selectedFull[this.selectedFull.length - 1], 'comment', 'Client/Customer: ' + snap.val().payerName)
              // console.log(snap.val())
              if (this.userInfo.driverComment) this.selectedFull[this.selectedFull.length - 1].comment += '\n' + snap.val().comment
            }
          }
          if (!snap.val().taxes) this.$set(this.selectedFull[this.selectedFull.length - 1], 'taxes', '')
          if (!snap.val().taxesComment) this.$set(this.selectedFull[this.selectedFull.length - 1], 'taxesComment', '')
          if (!snap.val().transmitterCountry) this.$set(this.selectedFull[this.selectedFull.length - 1], 'transmitterCountry', '')
          if (!snap.val().receiverCountry) this.$set(this.selectedFull[this.selectedFull.length - 1], 'receiverCountry', '')
          if (!snap.val().billingDate) this.$set(this.selectedFull[this.selectedFull.length - 1], 'billingDate', this.formatDate(Date.now()))
          this.order = JSON.parse(JSON.stringify(this.selectedFull[0]))
        })
      })
    },
    evaluateFiltering (attr, val) {
      this.fields[attr] = val
      this.filteredSearchMethod()
    },
    addOrderAction () {
      if (this.addressbook.length === 0) {
        console.log('initializing addressbook')
        db.ref('database/transporter/' + this.companyUID + '/carnet').once('value').then((snap) => {
          let addressbookArray = []
          snap.forEach((element) => {
            let item = element.val()
            item.key = element.key
            addressbookArray.push(item)
          })
          this.addressbook = addressbookArray
        })
      }
    },
    filteredSearchMethod: _.debounce(function () {
      this.filterResults = []
      var processingCopy = this.processing.slice()
      if (this.$route.query.customView === true || this.$route.query.customView === 'true') {
        // Will filter by source if this.$route.query.source is specified in url
        if (this.$route.query.source) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.source || '').toLowerCase() === this.$route.query.source.toLowerCase()
          })
        }
        // Will filter by reference if this.$route.query.reference is specified in url
        if (this.$route.query.reference) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.numRef || '').toLowerCase() === this.$route.query.reference.toLowerCase()
          })
        }
        // Will filter by vin if this.$route.query.vin is specified in url
        if (this.$route.query.vin) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.vin || '').toLowerCase() === this.$route.query.vin.toLowerCase()
          })
        }
        // Will filter by billing if this.$route.query.billing is specified in url
        if (this.$route.query.billing) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.payerName || '').toLowerCase() === this.$route.query.billing.toLowerCase()
          })
        }
        // Will filter by delivery if this.$route.query.delivery is specified in url
        if (this.$route.query.delivery) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.receiverName || '').toLowerCase() === this.$route.query.delivery.toLowerCase()
          })
        }
        // Will filter by driver if this.$route.query.driver is specified in url
        if (this.$route.query.driver) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.driverName || '').toLowerCase() === this.$route.query.driver.toLowerCase()
          })
        }
        // Will filter by pickup if this.$route.query.pickup is specified in url
        if (this.$route.query.pickup) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.transmitterName || '').toLowerCase() === this.$route.query.pickup.toLowerCase()
          })
        }
        // Will filter by from if this.$route.query.from is specified in url
        if (this.$route.query.from) {
          processingCopy = processingCopy.filter((entry) => {
            return entry.creationDate > this.$route.query.from
          })
        }
        // Will filter by to if this.$route.query.to is specified in url
        if (this.$route.query.to) {
          processingCopy = processingCopy.filter((entry) => {
            return entry.creationDate < this.$route.query.to
          })
        }
        // Will filter by status if this.$route.query.status is specified in url
        if (this.$route.query.status) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.status || '').toLowerCase() === this.$route.query.status.toLowerCase()
          })
        }
        // Will filter by after date if this.$route.query.after is specified in url
        if (this.$route.query.after) {
          processingCopy = processingCopy.filter((entry) => {
            return entry.creationDate < moment().subtract(this.$route.query.after, 'days').valueOf()
          })
        }
        // Will filter by before date if this.$route.query.before is specified in url
        if (this.$route.query.before) {
          processingCopy = processingCopy.filter((entry) => {
            return entry.creationDate < moment().subtract(this.$route.query.before, 'days').valueOf()
          })
        }
        // Will filter by province of pickup if this.$route.query.provincePick is specified in url
        if (this.$route.query.provincePick) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.provincePick || '').toLowerCase() === this.$route.query.provincePick.toLowerCase()
          })
        }
        // Will filter by province of drop if this.$route.query.provinceDrop is specified in url
        if (this.$route.query.provinceDrop) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.provinceDrop || '').toLowerCase() === this.$route.query.provinceDrop.toLowerCase()
          })
        }
      }
      // Will filter by newNote if this.$route.query.newNote is specified in url
      if (this.$route.query.newNote) {
        processingCopy = processingCopy.filter((entry) => {
          return entry.read === false
        })
      }
      if (this.$route.query.newDate) {
        processingCopy = processingCopy.filter((entry) => {
          return entry.datePromis !== null && entry.datePromis !== '' && entry.datePromis !== undefined
        })
      }
      this.filterResults = processingCopy.filter((entry) => {
        var result = true
        for (var attr in this.fields) {
          if (this.fields[attr] !== '') {
            var reg = this.fields[attr].replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
            var re = new RegExp(reg, 'i')
            if (attr === 'creationDate') {
              let date = this.getDate(entry[attr])
              result = re.test(date)
            } else if (attr === 'status') {
              if (entry.status === 'Dispatch') result = re.test(this.$t('Search.status.dispatch'))
              else if (entry.status === 'Pick') result = re.test(this.$t('Search.status.pick'))
              else if (entry.status === 'Processing') result = re.test(this.$t('Search.status.processing'))
              else if (entry.status === 'Attente') result = re.test(this.$t('Search.status.waiting'))
              else if (entry.status === 'Transit') result = re.test(this.$t('Search.status.transit'))
              else if (entry.status === 'Drop') result = re.test(this.$t('Search.status.drop'))
              else if (entry.status === 'Cancel') result = re.test(this.$t('Search.status.canceled'))
              else if (entry.status === 'Terminée') result = re.test(this.$t('Search.status.finished'))
              else if (entry.status === 'Transférée') result = re.test(this.$t('Search.status.transfered'))
              else if (entry.status === 'Reject') result = re.test(this.$t('Search.status.rejected'))
              else result = false
            } else {
              result = re.test(entry[attr])
            }
          }
          if (result === false) break
        }
        return result
      })
      this.filterResults.reverse()
      this.sortBy(this.sort.current, true)
      let paginator = this.$refs.paginator
      let maxPage = Math.ceil(this.filterResults.length / paginator.per)
      if (paginator.currentPage + 1 > maxPage && maxPage !== 0) paginator.goToPage(1)
    }, 100),
    setAndSearch: function (event, section) {
      if (section === 'pickup') {
        // console.log(event)
        this.datalist.pickup = event.value
        this.datalist.pickupUid = event.key
        if (event.key !== null) {
          db.ref('users/dealersList/' + this.datalist.pickupUid).once('value').then((snap) => {
            if (snap.val()) {
              this.order.transmitterName = snap.val().name
              this.order.transmitterAddress = snap.val().address
              this.order.transmitterCity = snap.val().city
              this.order.transmitterPostcode = snap.val().postcode
              this.order.transmitterPhone = snap.val().phone
              this.order.transmitterEmail = snap.val().receptionEmail || ''
              this.order.transmitterFax = snap.val().fax
              this.order.transmitterProvince = snap.val().province
              this.order.transmitterCountry = snap.val().country
              // console.log(snap.val())
            }
            // this.order.transmitterContact = snap.val().contact
          }).catch(function (error) {
            console.log(error)
          })
          this.addressbook.forEach((entry) => {
            if (entry['key'] === this.datalist.pickupUid) {
              this.order.transmitterName = entry.name
              this.order.transmitterAddress = entry.address
              this.order.transmitterCity = entry.city
              this.order.transmitterPostcode = entry.postcode
              this.order.transmitterPhone = entry.phone
              this.order.transmitterEmail = entry.receptionEmail || ''
              this.order.transmitterFax = entry.fax
              this.order.transmitterProvince = entry.province
              this.order.transmitterCountry = entry.country
            }
          })
        }
      }
      if (section === 'delivery') {
        this.datalist.delivery = event.value
        this.datalist.deliveryUid = event.key
        if (event.key !== null) {
          db.ref('users/dealersList/' + this.datalist.deliveryUid).once('value').then((snap) => {
            if (snap.val()) {
              this.order.receiverName = snap.val().name
              this.order.receiverAddress = snap.val().address
              this.order.receiverCity = snap.val().city
              this.order.receiverPostcode = snap.val().postcode
              this.order.receiverPhone = snap.val().phone
              this.order.receiverEmail = snap.val().receptionEmail || ''
              this.order.receiverFax = snap.val().fax
              this.order.receiverProvince = snap.val().province
              this.order.receiverCountry = snap.val().country
              if (this.billingSame) this.order.sageID = snap.val().sageID
              this.backup.sageIDDelivery = snap.val().sageID
              this.onInputBillingSame()
            }
            // this.order.transmitterContact = snap.val().contact
          }).catch(function (error) {
            console.log(error)
          })
          this.addressbook.forEach((entry) => {
            if (entry['key'] === this.datalist.deliveryUid) {
              this.order.receiverName = entry.name
              this.order.receiverAddress = entry.address
              this.order.receiverCity = entry.city
              this.order.receiverPostcode = entry.postcode
              this.order.receiverPhone = entry.phone
              this.order.receiverEmail = entry.receptionEmail || ''
              this.order.receiverFax = entry.fax
              this.order.receiverProvince = entry.province
              this.order.receiverCountry = entry.country
              if (this.billingSame) this.order.sageID = entry.sageID
              this.backup.sageIDDelivery = entry.sageID
              this.onInputBillingSame()
            }
          })
        }
      }
      if (section === 'billing') {
        this.datalist.billing = event.value
        this.datalist.billingUid = event.key
        if (event.key !== null) {
          db.ref('users/dealersList/' + this.datalist.billingUid).once('value').then((snap) => {
            if (snap.val()) {
              this.order.payerName = snap.val().name
              this.order.payerAddress = snap.val().address
              this.order.payerCity = snap.val().city
              this.order.payerPostcode = snap.val().postcode
              this.order.payerPhone = snap.val().phone
              this.order.payerEmail = snap.val().receptionEmail || ''
              this.order.payerFax = snap.val().fax
              this.order.payerProvince = snap.val().province
              this.order.payerCountry = snap.val().country
              this.order.sageID = snap.val().sageID
            }
            // this.order.transmitterContact = snap.val().contact
          }).catch(function (error) {
            console.log(error)
          })
          this.addressbook.forEach((entry) => {
            if (entry['key'] === this.datalist.billingUid) {
              this.order.payerName = entry.name
              this.order.payerAddress = entry.address
              this.order.payerCity = entry.city
              this.order.payerPostcode = entry.postcode
              this.order.payerPhone = entry.phone
              this.order.payerEmail = entry.receptionEmail || ''
              this.order.payerFax = entry.fax
              this.order.payerProvince = entry.province
              this.order.payerCountry = entry.country
              this.order.sageID = entry.sageID
              console.log(entry)
            }
          })
        }
      }
    },
    onInputBillingSame: function () {
      if (this.billingSame) {
        this.order.payerAddress = this.order.receiverAddress
        this.order.payerCity = this.order.receiverCity
        this.order.payerContact = this.order.receiverContact
        this.order.payerFax = this.order.receiverFax
        this.order.payerName = this.order.receiverName
        this.order.payerPhone = this.order.receiverPhone
        this.order.payerEmail = this.order.receiverEmail
        this.order.payerPostcode = this.order.receiverPostcode
        this.order.payerProvince = this.order.receiverProvince
        this.order.payerCountry = this.order.receiverCountry
      }
    },
    clear: function () {
      for (let attr in this.order) {
        this.order[attr] = ''
      }
      this.order.status = 'Processing'
      this.order.latitude = 0.001
      this.order.longitude = 0.001
      this.order.nbDispatch = 0
      for (let attr in this.datalist) {
        this.datalist[attr] = ''
      }
      this.vehicles = []
      this.VIN = ''
      this.MAKE = ''
      this.MODEL = ''
      this.YEAR = ''
      for (let attr in this.newCustomView) {
        this.newCustomView[attr] = ''
      }
    },
    addOrder: function () {
      var cigle = this.$store.state.userInfo.cigle
      var name = this.$store.state.userInfo.name
      this.order.transpCigle = cigle
      this.order.transpName = name
      this.addCustomer()
      for (var attr in this.order) {
        if (this.order[attr] === undefined) this.order[attr] = ''
      }
      this.vehicles.forEach((element) => {
        this.order.vin = element.vin
        this.order.make = element.make
        this.order.model = element.model
        this.order.year = element.year
        db.ref('test/transporter/' + this.companyUID + '/newDeliveries').push().set(this.order).then(() => {
          // ======================== ADD ORDER LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'ADD_ORDER', 'date': Date.now(), 'targetName': this.order.payerName})
          // ======================== ADD ORDER LOG =======================
        }).catch(function (error) {
          console.log(error)
        })
      })
      this.clear()
      this.closedModal = !this.closedModal
    },
    addVehicle: function () {
      this.vehicles.push({vin: this.VIN, make: this.MAKE, model: this.MODEL, year: this.YEAR.toString()})
      this.VIN = ''
      this.MAKE = ''
      this.MODEL = ''
      this.YEAR = ''
    },
    getDate: function (timestamp) {
      var date = new Date(timestamp)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    },
    formatDate (date) {
      var fdate = new Date(date)
      return fdate.getFullYear() + '-' + ('0' + (fdate.getMonth() + 1)).slice(-2) + '-' + ('0' + fdate.getUTCDate()).slice(-2)
    },
    print: function (order) {
      if (!order.isPrinted) db.ref('test/transporter/' + this.companyUID + '/deliveries/' + order['.key']).update({'isPrinted': true})
    },
    validate: function (vin) {
      // vin test: 1GTR2VE73CZ288102
      // console.log(vin)
      window.axios.get('https://dev.transport.keepneye.com/infobemaster/decode/decodevin/' + vin).then((response) => {
        console.log(response)
        this.MAKE = response.data.make
        this.MODEL = response.data.model
        this.YEAR = response.data.year.toString()
        if (this.MAKE === undefined) this.MAKE = ''
        if (this.MODEL === undefined) this.MODEL = ''
        if (this.YEAR === undefined) this.YEAR = ''
      }).catch((error) => console.log(error))
    },
    addCustomer: function () {
      var order = this.order
      if (this.deliverySave) {
        let savedDelivery = {
          'address': order.receiverAddress,
          'city': order.receiverCity,
          'contact': order.receiverContact,
          'fax': order.receiverFax,
          'name': order.receiverName,
          'receptionEmail': order.receiverEmail,
          'postcode': order.receiverPostcode,
          'country': order.receiverCountry,
          'province': order.receiverProvince,
          'phone': order.receiverPhone
        }
        db.ref('database/transporter/' + this.companyUID + '/carnet').push().set(savedDelivery)
      }
      if (this.pickupSave) {
        let savedPickup = {
          'address': order.transmitterAddress,
          'city': order.transmitterCity,
          'contact': order.transmitterContact,
          'fax': order.transmitterFax,
          'name': order.transmitterName,
          'receptionEmail': order.transmitterEmail,
          'postcode': order.transmitterPostcode,
          'country': order.transmitterCountry,
          'province': order.transmitterProvince,
          'phone': order.transmitterPhone
        }
        db.ref('database/transporter/' + this.companyUID + '/carnet').push().set(savedPickup)
      }
    },
    sortBy (criteria, newEntry) {
      if (this.sort.current === criteria && !newEntry) {
        this.sort.desc = !this.sort.desc
      } else if (!newEntry) {
        this.sort.desc = true
        this.sort.current = criteria
      }
      this.filterResults.sort((a, b) => {
        if (a[criteria] === undefined) a[criteria] = ''
        if (b[criteria] === undefined) b[criteria] = ''
        var A = a[criteria]
        var B = b[criteria]
        if (criteria !== 'creationDate' && criteria !== '.key') {
          A = a[criteria].toUpperCase() // ignore upper and lowercase
          B = b[criteria].toUpperCase() // ignore upper and lowercase
        } else {
          A = parseInt(a[criteria])
          B = parseInt(b[criteria])
        }
        if (!this.sort.desc) {
          if (A < B) {
            return -1
          }
          if (A > B) {
            return 1
          }
        } else {
          if (A > B) {
            return -1
          }
          if (A < B) {
            return 1
          }
        }
        // names must be equal
        return 0
      })
    }
  },
  computed: {
    filterResultsWithOrder () {
      let newArray = []
      this.filterResults.forEach((element) => {
        let newEle = element
        newEle.order = element['.key']
        newArray.push(element)
      })
      return newArray
    },
    formCompleted: function () {
      var order = this.order
      return (
        this.vehicles.length !== 0 &&
        order.receiverName !== '' &&
        order.receiverAddress !== '' &&
        order.receiverCountry !== '' &&
        order.receiverCity !== '' &&
        order.receiverPostcode !== '' &&
        order.receiverProvince !== '' &&
        order.payerName !== '' &&
        order.payerAddress !== '' &&
        order.payerCountry !== '' &&
        order.payerCity !== '' &&
        order.payerPostcode !== '' &&
        order.payerProvince !== '' &&
        order.transmitterName !== '' &&
        order.transmitterAddress !== '' &&
        order.transmitterCountry !== '' &&
        order.transmitterCity !== '' &&
        order.transmitterPostcode !== '' &&
        order.transmitterProvince !== '' &&
        ((this.isSageOne && order.price !== '') || !this.isSageOne))
    },
    sageOneCheck () {
      return ((this.$store.state.userInfo.isSageOne && this.order.sageID !== '' && this.order.sageID !== undefined) || !this.$store.state.userInfo.isSageOne)
    },
    allOrderID () {
      var orderIDs = ''
      this.selected.forEach((element, index) => {
        index !== 0 ? orderIDs += '+' + element : orderIDs += element
      })
      return orderIDs
    },
    allBillingFieldCompleted () {
      var result = true
      this.selectedFull.forEach((element) => {
        if (element.taxes === '' || element.price === '' || element.taxes === undefined || element.price === undefined || element.sageID === '' || element.sageID === undefined) result = false
      })
      return result
    },
    dispatchFormFilled () {
      return this.dispatchOrder.chauffeur !== '' &&
        this.order.transmitterName !== '' &&
        this.order.transmitterAddress !== '' &&
        this.order.transmitterCountry !== '' &&
        this.order.transmitterCity !== '' &&
        this.order.transmitterPostcode !== '' &&
        this.order.transmitterProvince !== '' &&
        this.order.receiverName !== '' &&
        this.order.receiverAddress !== '' &&
        this.order.receiverCountry !== '' &&
        this.order.receiverCity !== '' &&
        this.order.receiverPostcode !== '' &&
        this.order.receiverProvince !== ''
    },
    companyUID () {
      return this.$store.state.authorization.company
    },
    uid () {
      return this.$store.state.user.uid
    },
    sageIDonly () {
      return this.addressbook.filter(customer => customer.sageID)
    },
    isSageOne () {
      return this.$store.state.userInfo.isSageOne
    },
    userInfo () {
      return this.$store.state.userInfo
    },
    hasIntegration () {
      return this.$store.state.userInfo.hasIntegration
    },
    isDateRoute () {
      return this.$route.query.newDate
    },
    newCount () {
      let count = {processing: 0, dispatch: 0, pick: 0, transit: 0, drop: 0, transfer: 0, reject: 0, waiting: 0, newNote: 0, newDate: 0}
      this.processing.forEach((o) => {
        if (o.read === false) count.newNote++
      })
      this.processing.forEach((o) => {
        if (o.datePromis !== null && o.datePromis !== '' && o.datePromis !== undefined) {
          var fdate = new Date(o.datePromis)
          var today = new Date()
          today.setHours(0, 0, 0, 0)
          if (fdate <= today) {
            count.newDate++
          }
        }
      })
      this.filterResults.forEach((o) => {
        if (o.status === 'Processing') count.processing++
        if (o.status === 'Dispatch') count.dispatch++
        if (o.status === 'Pick') count.pick++
        if (o.status === 'Transit') count.transit++
        if (o.status === 'Drop') count.drop++
        if (o.status === 'Transférée') count.transfer++
        if (o.status === 'Reject') count.reject++
        if (o.status === 'Attente') count.waiting++
      })
      return count
    },
    isAdmin () {
      return this.$store.state.authorization.role === 'Admin'
    }
  },
  watch: {
    processing: function () {
      this.filteredSearchMethod()
    },
    billingSame: function (val) {
      var order = this.order
      if (!val) {
        order.payerAddress = ''
        order.payerCity = ''
        order.payerContact = ''
        order.payerFax = ''
        order.payerName = ''
        order.payerPhone = ''
        order.payerEmail = ''
        order.payerPostcode = ''
        order.payerProvince = ''
        order.payerCountry = ''
        order.sageID = ''
      } else {
        order.payerAddress = order.receiverAddress
        order.payerCity = order.receiverCity
        order.payerContact = order.receiverContact
        order.payerFax = order.receiverFax
        order.payerName = order.receiverName
        order.payerPhone = order.receiverPhone
        order.payerEmail = order.receiverEmail
        order.payerPostcode = order.receiverPostcode
        order.payerProvince = order.receiverProvince
        order.payerCountry = order.receiverCountry
        order.sageID = this.backup.sageIDDelivery || ''
        this.datalist.billing = ''
        this.datalist.billingUid = ''
      }
    },
    '$route.query': function (val) {
      // console.log(val)
      this.filteredSearchMethod()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table thead th{
  border-bottom: 1px solid #eceeef;
  border-top: none;
}
input, button{
  cursor: pointer;
}
#addOrder, #customView{
  position: relative;
}
#orders{

}
.printed{
  background-color: #79cc79 !important;
  border-color: #79cc79 !important;
}
.kne-tab:hover{
  color: #f7941e !important;
}
.kne-tab.active{
  color: #f7941e !important;
}
th{
  resize: horizontal;
}
.view {
  padding-left: 11rem;
}
.sidebar {
  width: 10.5rem;
}
.current{
  border-left: 3px solid #f7941e;
}
</style>



// WEBPACK FOOTER //
// OrderCurrent.vue?11913572